import React from "react";
import { Form, Button } from "react-bootstrap";
import { Search, FileText, FileSpreadsheet } from "lucide-react";

const styles = {
  input: {
    paddingLeft: 36,
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    fontSize: 13.5,
    height: 40,
  },
  icon: { position: "absolute", left: 12, top: 12, color: "#9CA3AF" },
 btnExport: {
    border: "1px solid #4F46E5",
    color: "#fff",
    background: "#2E5CB8",
    borderRadius: 8,
    fontSize: 13.5,
    fontWeight: 500,
  },
};

const ReportToolbar = ({
  search,
  onSearchChange,
  exporting,
  onExportPDF,
  onExportExcel,
}) => (
  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div className="position-relative" style={{ maxWidth: 420, width: "100%" }}>
      <Search size={16} style={styles.icon} />
      <Form.Control
        style={styles.input}
        placeholder="Search by employee, module, work nature, details..."
                value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
    <div>
      <Button
        variant="outline-secondary"
        className="me-2"
        style={styles.btnExport}
        onClick={onExportPDF}
        disabled={exporting === "pdf"}
      >
        <FileText size={15} className="me-1" />
        {exporting === "pdf" ? "Exporting…" : "Export PDF"}
      </Button>
      <Button
        variant="outline-secondary"
        style={styles.btnExport}
        onClick={onExportExcel}
        disabled={exporting === "excel"}
      >
        <FileSpreadsheet size={15} className="me-1" />
        {exporting === "excel" ? "Exporting…" : "Export Excel"}
      </Button>
    </div>
  </div>
);

export default ReportToolbar;
